/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import DTOLeaveHistoryViewModal from './DTOLeaveHistoryViewModal';
import LeaveHistoryViewModalPresenter from './LeaveHistoryViewModalPresenter';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  leaveHistoryViewData?: any;
  trans?: any;
}

const LeaveHistoryViewModalController = ({
  isModalOpen,
  closeModal,
  leaveHistoryViewData,
  trans,
}: ModalInterface) => {
  return (
    <>
      <DTOLeaveHistoryViewModal />

      <LeaveHistoryViewModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        leaveHistoryViewData={leaveHistoryViewData}
        trans={trans}
      />
    </>
  );
};

export default LeaveHistoryViewModalController;
